import {z} from "zod/v4";
import {ScheduledTransfer} from "../rpc/webrpc-client.gen";
import {BaseTimelineScene} from "../timeline/timeline.tsx";
import {makeVenuePlace} from "../tq/tqxx.tsx";
import {spawnTstzSpan} from "../tstzspan.ts";
import {TimelineTimeCoordinate} from "../timeline/timelineTimeCoordinate.tsx";

export function cmpScheduledTransfer(a: ScheduledTransfer, b: ScheduledTransfer): number {
    // sort of kludgey, but should sort as desired
    if (!a.arrivalWindow) {
        return -1;
    }
    if (!b.arrivalWindow) {
        return 1;
    }
    const rv = a.arrivalWindow.localeCompare(b.arrivalWindow);
    return rv;
}

export const ScheduledTransferScene = z.object({
    ...BaseTimelineScene.shape,
    subjectFlavor: z.literal("schedule"),
    subject: ScheduledTransfer,
});
export type ScheduledTransferScene = z.infer<typeof ScheduledTransferScene>;

export function synthScheduleScene(scheduledTransfer: ScheduledTransfer): ScheduledTransferScene {
    let when: TimelineTimeCoordinate;
    if (scheduledTransfer.arrivalWindow) {
        const span = spawnTstzSpan(scheduledTransfer.arrivalWindow);
        if (!span.isDegenerate()) {
            when = {span};
        } else {
            when = {at: span.lower!};
        }
    } else {
        when = {at: scheduledTransfer.posted};
    }

    return {
        subjectFlavor: "schedule",
        subject: scheduledTransfer,
        where: makeVenuePlace(scheduledTransfer.venue),
        when,
    };
}


